<!-- 发放商家券接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"traderCode":"2KNTYVWC","sellBillId":20160723162730110,"carCodeColor":1,"carCode":"粤EO08988"},
            responseCode: {
                "data": {
                    "sellBillId":279668974358796,
                    "couponLeftCount":111,
                    "couponSn":"GHKO987",
                    "carCode":"粤YAL555",
                    "grantTime":"20170910000000",
                    "validFrom":"20170910000000",
                    "validTo":"20170911000000"
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台给指定车辆发放电子优惠券，车辆在停车场可使用电子优惠券抵扣部分或全部停车费用",
                t_url: this.commonUrls.test+"sendCoupon",
                p_url: this.commonUrls.prod+"sendCoupon",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'traderCode', info2: '是', info3: 'String', info4: '授权商对应的商家代号' },
                        { info1: 'sellBillId', info2: '否', info3: 'Integer', info4: '销售账单ID,  结算类型为0时，必传' },
                        { info1: 'traderCouponTemplateCode', info2: '否', info3: 'String', info4: '优惠券模板编码, 结算类型为2时，必传 ' },
                        { info1: 'settlementType', info2: '否', info3: 'Integer', info4: '结算类型：0：销售结算【即先买后用】 2：使用结算【即用后结算】，默认为0' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'carCodeColor', info2: '否', info3: 'Integer', info4: '车牌颜色（1蓝色，2黄色，3白色，4黑色，5绿色），默认1蓝色' },
                        { info1: 'parkingCode', info2: '否', info3: 'String', info4: '停车记录号（优先匹配车牌，后匹配parkingCode，无牌车根据该字段发券需传入包含【未识别】的车牌号）' },
                       { info1: 'customValue', info2: '否', info3: 'Integer', info4: '自定义优惠券面值【结算模式为2时使用】 (当用后结算-面值类型为自定义时，必传且不能大于优惠面额上限)' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'sellBillId', info2: '是', info3: 'Integer', info4: '销售账单ID, 发券时需要用的重要参数' },
                        { info1: 'couponLeftCount', info2: '是', info3: 'Integer', info4: '券剩下可发放数量' },
                        { info1: 'couponSn', info2: '是', info3: 'String', info4: '发放券的唯一编号' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'grantTime', info2: '是', info3: 'String', info4: '券发放时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'validFrom', info2: '是', info3: 'String', info4: '车主领取的券有效开始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'validTo', info2: '是', info3: 'String', info4: '车主领取的券有效结束时间，yyyy-MM-dd HH:mm:ss' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/sendCoupon.vue